export enum TaskStatus {
	NotStarted,
	WOC,
	Completed,
	Canceled,
	Received,
}

export interface ClientTask {
	/**
	 * Task ID
	 */
	taskId: string;
	/**
	 * ID the the client this task belongs to
	 */
	clientId: string;
	/**
	 * Type of task (can be any string)
	 */
	type: string;
	/**
	 * Type of Task (0: New, 1: WIP, 2: Done, 3: Cancelled, 4: Received)
	 */
	status?: TaskStatus;
	/**
	 * Soft-delete flag
	 */
	deleted?: boolean;
	/**
	 * Task priority
	 */
	order?: number;
	/**
	 * Text that will will be used to list tasks
	 */
	label?: string;
	/**
	 * Object to save parameters to be used by the task (JSON)
	 */
	params?: any;
	/**
	 * Object to save dynamic data to be used by the task (JSON)
	 */
	data?: any;
	/**
	 * Array of steps for dynamic tasks
	 */
	steps?: TaskStep[];
	/**
	 * Date segment of ISO-8601 formatted task due date (YYYY-MM-DD)
	 * todo(refactor): update to required (breaking change)
	 */
	dueDate?: string;
	/**
	 * Client comment to staff about task
	 */
	comment?: string;
	/**
	 * Client comment explaining the reason why the task does not apply
	 */
	doesNotApplyComment?: string;
	/**
	 * ID of parent task. All Client Center tasks have a parent staff task to allow grouping
	 */
	taskGroupId: string;
	/**
	 * Date that task expires
	 */
	expirationDate: string;
	/**
	 * List of contacts assigned to task
	 */
	assignedContacts: AssignedContact[];
}
export interface TaskStep {
	/**
	 * Type of task step (can be any string)
	 */
	type: string;
	/**
	 * Object to save parameters to be used by the task step (JSON)
	 */
	params?: any;
	/**
	 * Object to save dynamic data to be used by the task step (JSON)
	 */
	doesNotApplyComment?: string;
	/**
	 * Client generic comment
	 */
	comment?: string;
}

export enum ClientTaskGroupType {
	Esign = 'ESIGN',
	Questionnaire = 'QUESTIONNAIRE',
	Payment_Request = 'PAYMENT_REQUEST',
	Document_Request = 'DOCUMENT_REQUEST',
	Document_Review = 'DOCUMENT_REVIEW'
}

export interface ClientTaskGroup {
	/**
	 * ID of this TaskGroup.
	 */
	id: string;
	/**
	 * Type of the TaskGroup this Task belongs to.
	 */
	type: ClientTaskGroupType;
	/**
	 * ID of the client this TaskGroup belongs to.
	 */
	clientId: string;
	/**
	 * Identifiers for contents of task groups
	 */
	tags: string[];
	/**
	 * Due date of task group
	 */
	dueDate: string;
	/**
	 * Expiration date of task group
	 */
	expirationDate: string;
	/**
	 * Array of all tasks in task group
	 */
	tasks: ClientTask[];
	/**
	 * Status of the TaskGroup
	 */
	status: TaskStatus;
}

export interface AssignedContact {
	id: string;
	userId: string;
	name: string;
	showTooltip: boolean;
	tooltipChecked: boolean;
	clientCenterEnabled: boolean;
}

export interface WidgetData {
	id: string;
	dueDate: string;
	assignedContacts: AssignedContact[];
	label: string;
	statusLabel: string;
	status: TaskStatus;
	pastDue: boolean;
	subject: string;
	canEdit: boolean;
	type: ClientTaskGroupType;
	showBusyLoader: boolean;
	esignInfo?: string;
	showTooltip: boolean;
	tooltipChecked: boolean;
}
